import styled, { css } from 'styled-components';

import { TransitionDuration } from 'design-system/variables/transitions';
import ImageIdBarcodeGuide from 'images/pictographs/barcode-pdf417-guide.svg';

const Positioner = styled('div')<{ mirrored: boolean }>`
  ${({ mirrored }) =>
    mirrored &&
    css`
      transform: scale(-1, 1);
    `};
  width: 100%;
`;

interface IdBarcodeGuideProps {
  mirrored?: boolean;
  hideGuide?: boolean;
}

export default function IdBarcodeGuide({
  mirrored = false,
  hideGuide = false,
}: IdBarcodeGuideProps) {
  // inset needs to be percentage-based to make the overlay take the right
  // amount of space on mobile devices, where the size of the viewport scales.
  return (
    <Positioner data-test='id-back-guide' mirrored={mirrored}>
      <div style={{ paddingBottom: '35%', position: 'relative', width: '100%' }}>
        <div style={{ position: 'absolute', inset: '17.75%' }}>
          <ImageIdBarcodeGuide
            style={{
              height: '100%',
              objectFit: 'cover',
              opacity: hideGuide ? 0 : 1,
              position: 'absolute',
              transition: `opacity ${TransitionDuration.Fast}`,
              width: '100%',
            }}
          />
        </div>
      </div>
    </Positioner>
  );
}
